import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locales/de';
import en from './locales/en';
import tr from './locales/tr';

const STORAGE_KEY = 'murat-lang';
const SUPPORTED = ['de', 'en', 'tr'];

const detectCountryLang = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz === 'Europe/Berlin' || tz === 'Europe/Busingen') return 'de';
    if (tz === 'Europe/Istanbul') return 'tr';
  } catch (e) {
    // ignore
  }
  return 'en';
};

const stored =
  typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
const initial =
  (SUPPORTED.includes(stored) && stored) || detectCountryLang();

i18n.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    en: { translation: en },
    tr: { translation: tr },
  },
  lng: initial,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnObjects: true,
});

i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, lng);
    document.documentElement.setAttribute('lang', lng);
  }
});

if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('lang', initial);
}

export default i18n;
